import React from 'react';
import { Modal, makeStyles, Theme, createStyles, Backdrop, Fade } from '@material-ui/core';
import { CreateModeratorForm } from './CreateModeratorForm';
import { useCancelRoute } from 'hooks';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    form: {
      width: '25%',
      padding: '15px',
      backgroundColor: theme.palette.background.paper,
      border: '0px',
      borderRadius: '2px',
      boxShadow: theme.shadows[5],
    },
  })
);

export const CreateModeratorPage = () => {
  const classes = useStyles();

  const { onCancel } = useCancelRoute('/moderators');

  return (
    <Modal
      open={true}
      onClose={onCancel}
      aria-labelledby="Добавление администратора"
      aria-describedby="Используйте эту форму для создания нового администратора"
      className={classes.modal}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={true}>
        <div className={classes.form}>
          <CreateModeratorForm onClose={onCancel} />
        </div>
      </Fade>
    </Modal>
  );
};
